import styled from "styled-components";
import { ReactComponent as ReloadIcon } from "../../../../assets/img/icons/reload.svg";
import { ReactComponent as SearchBulb } from "../../../../assets/img/icons/SearchBulb.svg";
import { ReactComponent as SearchCross } from "../../../../assets/img/icons/SearchCross.svg";
import SearchAdvance from "../../../../assets/img/icons/SearchAdvance.svg";
import { useLocation, useHistory } from "react-router-dom";

import SearchTermsContainer from "./SearchTermsContainer";
import React, { useState, useEffect, useRef } from "react";
import SearchTermExtended from "./SearchTermExtended";
import SavedSearch from "./SavedSearch";
import UpdateKeywords from "./UpdateKeywords";
import { useSelector } from "react-redux";
import CreateCampaign from "modules/Campaigns/CampaignAssets/Components/CreateCampaign";
import { PATH_MY_ACCOUNTS } from "../../../../constants/index";
import store from "store";
import { PREVIEW_ARTICLE } from "constants/actionTypes";
import { isSmallScreen, getQueryParam, removeOnClickBubble } from "utils";
import { getCompanyIntent, resetSearchedArticles, getIntentData } from "../actions";
import { GLOBAL_ACTION } from "modules/GlobalActions";

const SearchContentBar = (props) => {
  const searchNode = useRef();
  const searchInput = useRef();
  const searchInputContainer = useRef();
  const {
    onSearch,
    onEdit,
    editable,
    smartSearchTerms,
    searchTerms,
    setSearchTerms,
    extendedSearchTerms,
    setExtendedSearchTerms,
    disableSaveSearch = false,
    disableHintContent = false,
    onExtendedSearchCounterClicked,
    interestedPage,
    selectedTab,
    setAccountsSearchMode,
    resetSearchAccounts,
    isContentPage,
    createCampaignFlow,
    CrossRight,
  } = props;
  // console.log(smartSearchTerms, searchTerms, extendedSearchTerms);
  const assetCount = useSelector((state) => state.dragDrop.selectedIds.length);
  const isOverlay = useSelector((state) => state.uiReducer.overlay);
  const [showHint, setShowHint] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const advancedSearchCheck = useSelector((state) => state.uiReducer.advancedSearchCheck);

  let location = useLocation();
  let history = useHistory();
  let searchPlaceHolder =
    selectedTab === PATH_MY_ACCOUNTS ? "Search Companies" : "Search for keywords, ideas, concepts or companies…";

  let crossIcon = document.getElementsByClassName("clear-item")[0];
  let searchIcon = document.getElementsByClassName("search-icon")[0];

  // common util to split seasrch terms and populate extended/main search field
  const updateSearchTerms = (currentSearchTerms) => {
    // set search terms count based on characters
    //convert all to small case
    currentSearchTerms = currentSearchTerms.map((v) => v.toLowerCase().replace(" and ", " AND "));
    // add only unique terms
    currentSearchTerms = [...new Set(currentSearchTerms)];

    let searchQuery = "";
    // let searchTermsSplitter = extendedSearchTerms.length == 0 ? 5 : searchTerms.length;
    let searchTermsSplitter = 100;
    let charactersLimit = 45;
    let searchElementWidth = searchNode.current.offsetWidth;
    if (searchElementWidth <= 1000) {
      charactersLimit = 25;
    }

    let fontSize = getCanvasFontSize(searchNode.current);
    // console.log('getCanvasFontSize ', fontSize)

    let searchIconWidth = 16 + 16;
    if (searchIcon) {
      let style = window.getComputedStyle(searchIcon);
      let mL = getNumericValue(style.marginLeft, 10);
      let mR = getNumericValue(style.marginRight, 10);
      let pL = getNumericValue(style.paddingLeft, 10);
      let pR = getNumericValue(style.paddingRight, 10);
      searchIconWidth = searchIcon.offsetWidth + mL + mR + pL + pR;
    } else {
      searchIcon = document.getElementsByClassName("search-icon")[0];
    }

    let crossIconWidth = 12 + 12;
    if (crossIcon) {
      let style = window.getComputedStyle(crossIcon);
      let mL = getNumericValue(style.marginLeft, 10);
      let mR = getNumericValue(style.marginRight, 10);
      let pL = getNumericValue(style.paddingLeft, 10);
      let pR = getNumericValue(style.paddingRight, 10);
      crossIconWidth = crossIcon.offsetWidth + mL + mR + pL + pR;
    } else {
      crossIcon = document.getElementsByClassName("clear-item")[0];
    }

    let iconsWidth = searchIconWidth + crossIconWidth;
    // console.log('searchNode ', searchNode.current)
    // console.log('searchNode Width ', searchNode.current.offsetWidth)
    // console.log('icons width: ', iconsWidth)

    const wholeWidth = searchInputContainer.current.offsetWidth;
    let sixityPercentWholeWidth = wholeWidth * 0.6; //60% of width
    // console.log('60% of width ', wholeWidth, ' : ', sixityPercentWholeWidth)
    let occupiedWidth = 0;
    currentSearchTerms.every((element, index) => {
      searchQuery += element;
      let widthOfWords = getTextWidth(element, fontSize);
      occupiedWidth += widthOfWords + iconsWidth + 7;
      // console.log('occupied width: ', occupiedWidth)

      if (occupiedWidth > sixityPercentWholeWidth) {
        // console.log('inside if width > 0.6')
        searchTermsSplitter = index;
        return false;
      }

      // if (searchQuery.length > charactersLimit) {
      //   searchTermsSplitter = index;
      //   return false;
      // }
      return true;
    });

    // show cross on search if search terms exists
    setShowReset(currentSearchTerms.length > 0);
    if (currentSearchTerms.length === 0) {
      resetSearch();
    } else if (currentSearchTerms.length < searchTermsSplitter) {
      setSearchTerms(currentSearchTerms);
      setExtendedSearchTerms([]);
    } else {
      setSearchTerms(currentSearchTerms.slice(0, searchTermsSplitter));
      setExtendedSearchTerms(currentSearchTerms.slice(searchTermsSplitter, currentSearchTerms.length));
    }
  };

  // on , or enter click add search terms to current array and update article results
  const addSearchTerm = (event) => {
    if (event.key === "Enter" || event.key === ",") {
      let searchText = event.target.value;
      const currentSearchTerms = searchText
        .toLowerCase()
        .trim()
        .split(",")
        .filter((r) => r !== "");

      //fetch all search terms extended ones and in main bar
      let allSearchTerms = searchTerms.concat(extendedSearchTerms);

      currentSearchTerms.map((term) => {
        if (allSearchTerms.indexOf(term.trim()) === -1) {
          if (term.trim() !== "") allSearchTerms.push(term.trim());
          updateSearchTerms(allSearchTerms);
        }
      });

      setSearchValue("");

      if (event.key === "Enter") {
        // update search results based on enter press
        onSearch(allSearchTerms);
        store.dispatch({
          type: GLOBAL_ACTION.ADVANCED_SEARCH_CHECK,
          payload: false,
        });
      }
      store.dispatch({
        // This action will update the searched terms in the store that are to be highlighted in the article preview sidebar
        type: PREVIEW_ARTICLE.UPDATE_SEARCH_TERMS,
        payload: allSearchTerms,
      });
    }
  };

  // on cross click remove search term from field
  const removeSearchTerm = (searchTermId, isExtended) => {
    let tmpSearchTerms = isExtended ? extendedSearchTerms : searchTerms;
    // find search term based on id
    tmpSearchTerms = tmpSearchTerms.filter((s, id) => id !== searchTermId);
    tmpSearchTerms = isExtended ? searchTerms.concat(tmpSearchTerms) : tmpSearchTerms.concat(extendedSearchTerms);

    updateSearchTerms(tmpSearchTerms);

    //search on remove keywords
    setSearchValue("");
    if (interestedPage) return;
    onSearch(tmpSearchTerms);
    if (tmpSearchTerms.length === 0 && setAccountsSearchMode) {
      setAccountsSearchMode(false);
      resetSearchAccounts();
    }
    store.dispatch({
      type: PREVIEW_ARTICLE.UPDATE_SEARCH_TERMS,
      payload: tmpSearchTerms,
    });
  };

  const handleSearchFocus = (e) => {
    if (!searchNode?.current) return;
    setShowHint(searchNode.current.contains(e.target)); // show search hint on search field click
    if (smartSearchTerms) onEdit(searchNode.current.contains(e.target));
  };

  useEffect(() => {
    let id = getQueryParam("companyid");
    let type = "company";
    if (id.length === 0) {
      id = getQueryParam("personid");
      type = "person";
    }
    if (id.length > 0) {
      getIntentData(id, type)
        .then((res) => {
          if (res.status === 200 && res.data.length > 0) {
            let intentData = res.data;
            updateSearchTerms(intentData);
            onSearch(intentData);
            store.dispatch({
              type: PREVIEW_ARTICLE.UPDATE_SEARCH_TERMS,
              payload: intentData,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (smartSearchTerms) updateSearchTerms(smartSearchTerms);
    document.addEventListener("mousedown", handleSearchFocus);
    return () => {
      document.removeEventListener("mousedown", handleSearchFocus);
    };
  }, []);

  const reloadSearch = () => {
    let allSearchTerms = searchTerms.concat(extendedSearchTerms);
    if (interestedPage) return;
    onSearch(allSearchTerms);
  };

  useEffect(() => {
    if (props.onFirstTime) {
      let allSearchTerms = searchTerms.concat(extendedSearchTerms);
      /**
       * When a user click on searchh content first tiem, this will be invoked and search result for the respective keywords
       * This only works once in the case of onBoarding
       */
      // updateSearchTerms(allSearchTerms);
      onSearch(allSearchTerms);
    }
  }, [props.onFirstTime]);

  useEffect(() => {
    const focusOutOfTextField = (e) => {
      if (searchNode.current) {
        searchInput.current.blur();
        setShowHint(false);
      }
    };
    window.addEventListener("scroll", focusOutOfTextField);
    return () => {
      window.removeEventListener("scroll", focusOutOfTextField);
    };
  }, []);

  const resetSearch = () => {
    //clear all arrays on reset click
    setSearchTerms([]);
    setExtendedSearchTerms([]);
    setShowReset(false);
    onSearch([]);
    setAccountsSearchMode(false);
    resetSearchedArticles();
    if (advancedSearchCheck) {
      store.dispatch({
        type: GLOBAL_ACTION.ADVANCED_SEARCH_CHECK,
        payload: false,
      });
    }
    store.dispatch({
      type: PREVIEW_ARTICLE.UPDATE_SEARCH_TERMS,
      payload: [],
    });
    // if (location.state?.fromPath === undefined) {
    //   history.push("/content/explorer");
    // } else {
    //   if (location.state.fromPath === "search") {
    //     history.push("/content/explorer");
    //   } else {
    //     onSearch([]);
    //     //* to empty out the search terms
    //   }
    // }
  };
  // console.log("ALL SEARCH TERMS", searchTerms + "," + extendedSearchTerms);

  useEffect(() => {
    if (props.searchTerms?.length === 0 && extendedSearchTerms.length === 0 && showReset) {
      setShowReset(false);
    }
  }, [props.searchTerms]);

  const isSmallScreenSize = isSmallScreen();

  const advancedSearchClickHandler = () => {
    store.dispatch({
      type: GLOBAL_ACTION.OPEN_ADVANCED_SEARCH_SIDEBAR,
    });
  };

  return (
    <>
      <Wrapper editable={editable} CrossRight={CrossRight}>
        <div className="row">
          <div
            className="col"
            // className={`${
            //   disableSaveSearch && !createCampaignFlow
            //     ? "col-12"
            //     : createCampaignFlow
            //     ? "col-10"
            //     : isContentPage && isSmallScreenSize
            //     ? "col-9"
            //     : "col-10"
            // }`}
          >
            <InsideWrapper>
              <div id="contentSearchBar" ref={searchNode} className="search-wraper">
                <div
                  ref={searchInputContainer}
                  className={`search-bar search-added  ${editable && showHint && "hint-active"}`}
                >
                  <span href="#" className="refresh-search">
                    {editable && <ReloadIcon onClick={reloadSearch} />}
                  </span>
                  <div className="search-terms d-flex flex-nowrap">
                    <SearchTermsContainer
                      editable={editable}
                      searchTerms={searchTerms}
                      onRemove={removeSearchTerm}
                      isExtended={false}
                    />
                    {!(editable && showHint) && extendedSearchTerms.length > 0 && (
                      <SearchTermExtended
                        count={extendedSearchTerms.length}
                        onClick={onExtendedSearchCounterClicked}
                      />
                    )}

                    <input
                      type="text"
                      name="search"
                      onChange={(e) => (e.target.value !== "," ? setSearchValue(e.target.value) : null)}
                      onKeyPress={(e) => addSearchTerm(e)}
                      className="search-input"
                      ref={searchInput}
                      placeholder={
                        searchTerms.length === 0 && extendedSearchTerms.length === 0 ? searchPlaceHolder : ""
                      }
                      value={searchValue}
                      autoComplete="off"
                      onFocus={(e) => setShowHint(true)}
                      // onBlur={(e) => setShowHint(false)}
                    />
                  </div>
                  {/* <AdvanceSearch show="d-block" /> */}
                  {!smartSearchTerms && showReset && (
                    <span className="clear-search">
                      <SearchCross onClick={resetSearch} />
                    </span>
                  )}
                </div>
                {editable && showHint && !disableHintContent && (
                  <div className="search-results show">
                    <div className="search-hint">
                      <SearchBulb />
                      <ul>
                        <li>• Add keywords separated by commas to get more tailored content.</li>
                        <li>
                          • Add “<strong>AND</strong>” between search terms to get results containing both search
                          terms. i.e. (Sony AND Playstation)
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {showHint && editable && extendedSearchTerms.length > 0 && (
                  <div className={`search-results show extented-kw `}>
                    <ul className={`results-list-term `}>
                      <div className="inner-wrapper">
                        <SearchTermsContainer
                          searchTerms={extendedSearchTerms}
                          onRemove={removeSearchTerm}
                          isExtended={true}
                        />
                      </div>
                    </ul>
                  </div>
                )}
              </div>
              <div
                hidden={history.location.pathname.includes("content/myaccounts") ? true : false}
                onClick={advancedSearchClickHandler}
                className={`advanced-search-style ${showHint && "z-index-class"}`}
              >
                <img
                  src={SearchAdvance}
                  style={{
                    borderLeft: `${isOverlay ? "" : "1px solid #dadada"}`,
                    padding: "0 5px",
                  }}
                />
                Advanced Search
              </div>
            </InsideWrapper>
          </div>
          {!disableSaveSearch && (
            <div className={isSmallScreenSize && isContentPage ? "col-3" : "col-2"}>
              {smartSearchTerms ? (
                <UpdateKeywords searchTerms={searchTerms} extendedSearchTerms={extendedSearchTerms} />
              ) : searchTerms.length === 0 && extendedSearchTerms.length === 0 ? (
                <SavedSearch
                  disabled={searchTerms?.length === 0 && extendedSearchTerms?.length === 0 ? true : false}
                />
              ) : (
                <CreateCampaign hideDynamic={true} keywords={searchTerms.concat(extendedSearchTerms)}>
                  <SavedSearch />
                </CreateCampaign>
              )}
            </div>
          )}
          {createCampaignFlow ? (
            <div
              className="saved-search-wrapper"
              // className={isSmallScreenSize && isContentPage ? "col-2" : "col-2"}
            >
              <CreateCampaign
                hideDynamic={true}
                disabled={searchTerms.length === 0 && extendedSearchTerms?.length === 0 ? true : false}
                keywords={searchTerms.concat(extendedSearchTerms)}
              >
                <SavedSearch
                  disabled={searchTerms.length === 0 && extendedSearchTerms?.length === 0 ? true : false}
                />
              </CreateCampaign>
            </div>
          ) : null}
        </div>
      </Wrapper>
    </>
  );
};

export default SearchContentBar;

const InsideWrapper = styled.div`
  position: relative;
  .advanced-search-style {
    font-size: 16px;
    color: #7e7e7e;
    font-family: "Roboto";
    weight: 700;
    margin-top: 8px;
    padding-left: 5px;
    /* border-left: 1px solid #dadada; */
    position: absolute;
    right: 18px;
    z-index: 10;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-top: 3px;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .z-index-class {
    z-index: 12;
  }
`;

const Wrapper = styled.div`
  .saved-search-wrapper {
    max-width: 180px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-width: 140px;
    }
  }
  .search-wraper {
    position: relative;
    width: 100%;

    .search-results {
      border-radius: 22px;
      position: absolute;
      background: rgb(247, 247, 247);
      top: -80px;
      left: 0;
      float: left;
      width: 100%;
      border: 1px solid #dadada;
      box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.12);
      overflow: hidden;
      transition: 0.5s;
      z-index: -1;
      opacity: 0;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        top: -65px;
        border-radius: 15px;
      }
      &.show {
        opacity: 1;
        z-index: 2;
        visibility: visible;
      }
      &.extented-kw {
        top: 15px;
      }
      ul.results-list {
        background: #fff;
        padding: 30px 20px 10px 55px;
        margin: 0;
        list-style: none;
        float: left;
        display: block;
        width: 100%;
        transition: 0.5s;
        li {
          color: #5e7079;
          font-size: 16px;
          line-height: 34px;
          padding: 0;
          list-style: none;
          width: 100%;
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          transition: 0.5s;
          span {
            color: #c5c5c5;
            font-size: 12px;
            font-family: "robotoregular", sans-serif;
          }
        }
      }
      ul.results-list-term {
        background: #fff;
        padding: 30px 20px 10px 55px;
        margin: 0;
        border-bottom-left-radius: 22px;
        border-bottom-right-radius: 22px;
        list-style: none;
        float: left;
        display: block;
        width: 100%;
        transition: 0.5s;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          border-bottom-left-radius: 15px;
          border-bottom-right-radius: 15px;
          padding: 20px 30px 5px 36px;
        }
        &.extended {
          margin-top: 10px;
        }
        &.empity {
          padding: 20px 20px 0 55px;
        }
        .inner-wrapper {
          > div {
            margin-bottom: 4px;
          }
          max-height: 280px;
          overflow-y: auto;
          scrollbar-width: thin;
          scrollbar-color: #001760 #efefef;
          ::-webkit-scrollbar {
            width: 5px;
            height: 5px;
            border-radius: 2px;
          }
          /* Track */
          ::-webkit-scrollbar-track {
            background: #efefef;
            margin-top: 10px;
            margin-bottom: 15px;
          }
          /* Handle */
          ::-webkit-scrollbar-thumb {
            background: #001760;
          }
          /* Handle on hover */
          ::-webkit-scrollbar-thumb:hover {
            background: #555;
          }
        }
        li {
          color: #5e7079;
          font-size: 16px;
          line-height: 34px;
          padding: 0;
          list-style: none;
          width: 100%;
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          transition: 0.5s;
          span {
            color: #c5c5c5;
            font-size: 12px;
            font-family: "robotoregular", sans-serif;
          }
        }
      }
      .relevant-theme,
      .relevant-company {
        border-top: 1px solid #dadada;
        padding: 10px 40px 30px 40px;
        background: #f7f7f7;
        float: left;
        width: 100%;
        transition: 0.5s;
        h3 {
          margin-bottom: 10px;
          color: #424b50;
          font-weight: 400;
          font-family: "Roboto Slab", serif;
          font-size: 18px;
          line-height: 34px;
        }
      }
      .relevant-keywords {
        padding: 10px 40px 30px 40px;
        background: #f7f7f7;
        float: left;
        width: 100%;
        transition: 0.5s;
        div {
          margin-bottom: 4px;
        }
        h3 {
          margin-bottom: 10px;
          color: #424b50;
          font-weight: 400;
          font-family: "Roboto Slab", serif;
          font-size: 18px;
          line-height: 34px;
        }
      }
      .search-hint {
        background: #def6e6;
        padding: 18px 25px 36px 25px;
        border-radius: 22px 22px 0 0;
        float: left;
        width: 100%;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          padding: 12px 25px 28px 25px;
          border-radius: 15px 15px 0 0;
        }
        svg {
          float: left;
          width: 35px;
          height: 39px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 25px;
          }
        }
        ul {
          margin: 0;
          float: left;
          padding-left: 15px;
          padding-top: 5px;
          li {
            color: #09a43a;
            font-size: 14px;
            font-weight: 400;
            list-style: none;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 10px;
            }
            strong {
              font-weight: 700;
            }
          }
        }
      }
    }
  }

  .search-bar {
    border-radius: 27px;
    background: ${(props) => (props.editable === false ? "#F2F2F2" : "#FFFFFF")};
    border: 1px solid ${(props) => (props.editable === false ? "#dadada" : "#dadada")};
    display: block;
    float: left;
    width: 100%;
    overflow: hidden;
    z-index: 2;
    position: relative;
    &.hint-active {
      z-index: 12;
      + .search-results.show {
        z-index: 11;
      }
    }

    .search-terms {
      width: calc(100% - 260px);
      overflow: hidden;
      float: left;
      margin-bottom: 3px;
    }
    span.clear-search {
      float: right;
      margin-top: 8px;
      margin-right: 12px;
      transition: 0.5s;
      position: absolute;
      right: 0px;
      right: ${(props) => props.CrossRight};
      cursor: pointer;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 3px;
      }
      svg {
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 9px;
          height: auto;
        }
      }
    }
    span.refresh-search {
      padding-right: 5px;
      border-right: 1px solid #dddddd;
      margin: ${(props) => (props.editable === false ? 0 : "8px")};
      float: left;
      cursor: pointer;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 13px;
      }
      svg {
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 14px;
          height: auto;
          vertical-align: bottom;
        }
      }
    }
    .search-input {
      float: left;
      border: none;
      outline: none;
      /* width: calc(100% - 90px); */
      width: 100%;
      display: block;
      color: #424b50;
      background-color: ${(props) => (props.editable === false ? "#F2F2F2" : "#FFFFFF")};
      font-weight: 100;
      font-size: 18px;
      margin-top: 5px;
      font-family: "robotoregular";
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px;
        margin-top: 3px;
      }
      &:hover,
      &:active,
      &:focus {
        border: none;
        outline: none;
      }
      &::-webkit-input-placeholder {
        font-family: "robotothin_italic";
        color: #c1c1c1;
      }
      &:-moz-placeholder {
        font-family: "robotothin_italic";
        color: #c1c1c1;
      }
      &::-moz-placeholder {
        font-family: "robotothin_italic";
        color: #c1c1c1;
      }
      &:-ms-input-placeholder {
        font-family: "robotothin_italic";
        color: #c1c1c1;
      }
    }
  }
`;

function getTextWidth(text, font) {
  // re-use canvas object for better performance
  const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
  const context = canvas.getContext("2d");
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
}

function getCssStyle(element, prop) {
  return window.getComputedStyle(element, null).getPropertyValue(prop);
}

function getCanvasFontSize(el = document.body) {
  const fontWeight = getCssStyle(el, "font-weight") || "normal";
  const fontSize = getCssStyle(el, "font-size") || "16px";
  const fontFamily = getCssStyle(el, "font-family") || "Times New Roman";

  return `${fontWeight} ${fontSize} ${fontFamily}`;
}

function getNumericValue(num, base) {
  const parsed = parseInt(num, base);
  if (isNaN(parsed)) {
    return 0;
  }
  return parsed;
}
